import { TYPICAL_JOURNEY_COOKIE } from "basket_and_checkout/shared/components/PDP/Pricing/utils"
import { ExperimentFlags } from "@shared/utils.experimentation"
import { enabledOpengateVariants } from "packages/acquisition/hooks/productFirst.contants"

const getTypicalJourneyStatusParamsFromCookies = (
  cookies: Record<string, unknown>
) => {
  const userSegment = cookies?.user_segment ?? "nonmember"
  const typicalJourneyCookieValue =
    cookies?.[TYPICAL_JOURNEY_COOKIE] ?? undefined
  const hasMembershipInBagCookieValue =
    cookies?.["bp-membership-in-bag"] ?? undefined

  let isProductFirstExperiment = false
  try {
    const experimentFlagsCookie = cookies?.["experiment-flags"] ?? undefined
    const parsedExperimentsFlags = experimentFlagsCookie
      ? JSON.parse(experimentFlagsCookie as "")
      : ""

    const opengateFlag =
      parsedExperimentsFlags?.[ExperimentFlags.PAGE_EXPERIMENT_OPENGATE]

    const newMapping =
      parsedExperimentsFlags?.[
        ExperimentFlags.PAGE_EXPERIMENT_NEW_OG_MAPPING
      ] === 1

    isProductFirstExperiment =
      enabledOpengateVariants.includes(opengateFlag) && newMapping
  } catch (err) {
    console.error(err)
  }

  return {
    isMember: userSegment === "member",
    hasTypicalJourney: typicalJourneyCookieValue === "1",
    hasMembershipInBag: hasMembershipInBagCookieValue === "1",
    isProductFirstExperiment,
  }
}

export const getTypicalJourneyStatus = (
  locale: string,
  cookies: Record<string, unknown>
) => {
  const {
    isMember,
    hasTypicalJourney,
    isProductFirstExperiment,
    hasMembershipInBag,
  } = getTypicalJourneyStatusParamsFromCookies(cookies)
  if (isMember || hasMembershipInBag) {
    return false
  }
  if (hasTypicalJourney) {
    return true
  }
  if (locale === "en-US" || isProductFirstExperiment) {
    return true
  }
  return false
}
